import React from "react";
import { Calendar } from "lucide-react";

const FloatingBookButton = () => (
  <a
    href="https://fresha.com/q/xL6X0AmExj48WA"
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-book-btn"
    aria-label="Have questions? Connect with us on Fresha"
    className="group fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#D4AF37] text-[#050505] pl-4 pr-5 py-4 rounded-full shadow-[0_8px_30px_rgba(212,175,55,0.35)] hover:shadow-[0_8px_40px_rgba(212,175,55,0.55)] transition-all duration-300 hover:-translate-y-1"
  >
    <span className="absolute inset-0 rounded-full bg-[#D4AF37] animate-ping opacity-20 pointer-events-none" />
    <Calendar className="w-5 h-5 relative shrink-0" />
    <span className="relative text-[10px] md:text-xs font-bold uppercase tracking-widest whitespace-nowrap">Have Questions? Connect With Us</span>
  </a>
);

export default FloatingBookButton;
